'use strict'

module.exports = inlineCode

var collapse = require('collapse-white-space')
var u = require('unist-builder')

/* Transform inline code. */
function inlineCode(h, node) {
  return h(node, 'code', [u('text', collapse(node.value))])
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/inline-code.js
// module id = 897
// module chunks = 95715928098905 168707334958949